function getYearAndMonth(inputDate: string) {
  const [year, month] = inputDate.split('-').map(Number)

  return { year, month }
}

export const useBook = () => {
  return {
    isNextMonth(inputDate: string) {
      if (inputDate) {
        const { year, month } = getYearAndMonth(inputDate)
        const now = new Date()
        const nextMonth = now.getMonth() + 1 === 12 ? 1 : now.getMonth() + 2
        const nextMonthYear =
          now.getMonth() + 1 === 12 ? now.getFullYear() + 1 : now.getFullYear()

        return year === nextMonthYear && month === nextMonth
      }

      return false
    },
    isPrevMonth(inputDate: string) {
      if (inputDate) {
        const { year, month } = getYearAndMonth(inputDate)
        const now = new Date()
        const prevMonth = now.getMonth() === 0 ? 11 : now.getMonth() - 1
        const prevMonthYear =
          now.getMonth() === 0 ? now.getFullYear() - 1 : now.getFullYear()

        return year === prevMonthYear && month - 1 === prevMonth
      }

      return false
    },
    isCurrentMonth(inputDate: string) {
      if (inputDate) {
        const { year, month } = getYearAndMonth(inputDate)
        const now = new Date()
        const currentYear = now.getFullYear()
        const currentMonth = now.getMonth() + 1

        return year === currentYear && month === currentMonth
      }

      return false
    },
    isOlderThanPrevMonth(inputDate: string) {
      if (inputDate) {
        const { year, month } = getYearAndMonth(inputDate)
        const now = new Date()
        const prevMonth = now.getMonth() === 0 ? 12 : now.getMonth()
        const prevMonthYear =
          now.getMonth() === 0 ? now.getFullYear() - 1 : now.getFullYear()

        return (
          year < prevMonthYear || (year === prevMonthYear && month < prevMonth)
        )
      }

      return false
    },
    genreToKey(genres: string[] = []) {
      const genre: string = genres.toString().toLocaleLowerCase()

      return genre.replaceAll('&', '').replaceAll(' ', '-')
    }
  }
}
